import * as z from 'zod/mini'
import { personFields } from '../../schemas/person'
import { EmployeeStatus } from '../../types'

/** An employee URL (`.../employees/:employeeId`), looked up by `EmployeeGuard` within the premise. */
export const employeeParams = z.object({ employeeId: z.uuid() })
export type EmployeeParams = z.infer<typeof employeeParams>

/**
 * Adds an employee by email, with the name the premise knows them by - required, so nobody is ever
 * shown blank (docs/employees.md). `activityIds` are resolved within the premise; one from elsewhere
 * is a 404.
 */
export const createEmployeeBody = z.object({
  firstName: personFields.firstName.check(z.minLength(1)),
  lastName: personFields.lastName.check(z.minLength(1)),
  email: personFields.email,
  activityIds: z.array(z.uuid()),
})
export type CreateEmployeeBody = z.infer<typeof createEmployeeBody>

export const updateEmployeeBody = z.partial(
  z.object({
    ...personFields,
    activityIds: z.array(z.uuid()),
  }),
)
export type UpdateEmployeeBody = z.infer<typeof updateEmployeeBody>

export const setEmployeeStatusBody = z.object({ status: z.enum(EmployeeStatus) })
export type SetEmployeeStatusBody = z.infer<typeof setEmployeeStatusBody>
